import api from '@/api';
import { API_BASE_URL } from '../../index';
import { WorkOrderSyntheticTotalCostRequest } from './work-order-synthetic-total-cost.types';

const CONTROLLER_URL = `${API_BASE_URL}/generate`;

export async function getWorkOrderFinancialReceipt(
  params: WorkOrderSyntheticTotalCostRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/work-order-synthetic-total-cost`,
    params,
  )) as unknown;

  return result as BlobPart;
}
